import {Component} from '@angular/core';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-partner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tekst-partner.component.html',
  styleUrl: './tekst-partner.component.scss',
})
export class TekstPartnerComponent {}
